import { Form, Input } from "antd";
import { useTranslation } from "react-i18next";

const Address = ({ required }) => {
  const { t } = useTranslation();
  return (
    <Form.Item name="address" label={t("billing.addressLabel")} rules={[{ required: required, message: t("billing.addressRequired") }]} hasFeedback>
      <Input placeholder={t("billing.addressPlaceholder")} />
    </Form.Item>
  );
};

export default Address;
